import Card from 'shared-assets/components/Card';
import Modal from 'shared-assets/components/Modal';
import PropTypes from 'prop-types';
import React from 'react';

export const ControlledModalComponent = ({ open, children, ...props }) => {
  return (
    <If condition={open}>
      <Modal {...props}>{children}</Modal>
    </If>
  );
};

ControlledModalComponent.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.string,
};

ControlledModalComponent.defaultProps = {
  open: false,
  maxWidth: '38vw',
};

export const modalSize = {
  default: 'default',
  large: 'large',
  extraLarge: 'extra-large',
};

const modalSizeToStyle = {
  large: '60vw',
  'extra-large': '82vw',
  default: '38vw',
};

export const ModalContainer = props => {
  return (
    <ControlledModalComponent open={props.open}>
      {props.children}
    </ControlledModalComponent>
  );
};

ModalContainer.defaultProps = {
  open: false,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

ModalContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  open: PropTypes.bool,
};

const ModalCard = props => {
  return (
    <ControlledModalComponent open={props.open}>
      <Card
        header={props.header}
        footer={props.footer}
        onClose={props.onClose}
        closeIcon={props.closeIcon}
        style={{
          maxWidth: modalSizeToStyle[props.size],
          margin: '0 auto',
          ...props.cardStyle,
        }}
        bodyStyle={props.bodyStyle}
      >
        {props.children}
      </Card>
    </ControlledModalComponent>
  );
};

ModalCard.defaultProps = {
  bodyStyle: {},
  cardStyle: {},
  children: '',
  closeIcon: true,
  footer: '',
  header: '',
  onClose: () => {},
  open: false,
  size: modalSize.default,
};

ModalCard.propTypes = {
  bodyStyle: PropTypes.object,
  cardStyle: PropTypes.object,
  children: PropTypes.node,
  closeIcon: PropTypes.bool,
  footer: PropTypes.node,
  header: PropTypes.node,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(modalSize)),
};

export default ModalCard;
